import React from "react";

const RegionContext = React.createContext();

export default RegionContext;
